import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import LeftToolbar from "./LeftToolbar";
import CenterControls from "./CenterControls";
import RightSpeedControl from "./RightSpeedControl";
import { SHOW_PLAYBACK_SPEED } from "../../utils/playbackHelper";

const PlaybackControlBar = ({
  isPlaying,
  onTogglePlay,
  muted,
  onToggleMuted,
  onSnapshot,
  snapshotDisabled = false,
  zoom,
  onZoomChange,
  zoomDisabled = false,
  isTrimming = false,
  onToggleTrim,
  trimDisabled = false,
  timeScale,
  onSelectTimeScale,
  playbackTime,
  eventDates,
  onApplyTime,
  onCalendarMonthChange,
  onShiftPlayback,
  playbackSpeed,
  onCycleSpeed,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        minHeight: 34,
      }}
    >
      <LeftToolbar
        isPlaying={isPlaying}
        onTogglePlay={onTogglePlay}
        muted={muted}
        onToggleMuted={onToggleMuted}
        onSnapshot={onSnapshot}
        snapshotDisabled={snapshotDisabled}
        zoom={zoom}
        onZoomChange={onZoomChange}
        zoomDisabled={zoomDisabled}
        isTrimming={isTrimming}
        onToggleTrim={onToggleTrim}
        trimDisabled={trimDisabled}
        timeScale={timeScale}
        onSelectTimeScale={onSelectTimeScale}
      />
      <CenterControls
        playbackTime={playbackTime}
        eventDates={eventDates}
        onApplyTime={onApplyTime}
        onCalendarMonthChange={onCalendarMonthChange}
        onShiftPlayback={onShiftPlayback}
      />
      <Box
        aria-hidden={!SHOW_PLAYBACK_SPEED}
        sx={{
          visibility: SHOW_PLAYBACK_SPEED ? "visible" : "hidden",
          pointerEvents: SHOW_PLAYBACK_SPEED ? "auto" : "none",
        }}
      >
        <RightSpeedControl
          playbackSpeed={playbackSpeed}
          onCycleSpeed={onCycleSpeed}
        />
      </Box>
    </Box>
  );
};

PlaybackControlBar.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  onTogglePlay: PropTypes.func.isRequired,
  muted: PropTypes.bool.isRequired,
  onToggleMuted: PropTypes.func.isRequired,
  onSnapshot: PropTypes.func.isRequired,
  snapshotDisabled: PropTypes.bool,
  zoom: PropTypes.number.isRequired,
  onZoomChange: PropTypes.func.isRequired,
  zoomDisabled: PropTypes.bool,
  isTrimming: PropTypes.bool,
  onToggleTrim: PropTypes.func.isRequired,
  trimDisabled: PropTypes.bool,
  timeScale: PropTypes.string.isRequired,
  onSelectTimeScale: PropTypes.func.isRequired,
  playbackTime: PropTypes.number.isRequired,
  eventDates: PropTypes.arrayOf(PropTypes.string).isRequired,
  onApplyTime: PropTypes.func.isRequired,
  onCalendarMonthChange: PropTypes.func.isRequired,
  onShiftPlayback: PropTypes.func.isRequired,
  playbackSpeed: PropTypes.string.isRequired,
  onCycleSpeed: PropTypes.func.isRequired,
};

export default PlaybackControlBar;
